export default __webpack_public_path__ + "static/benefits-revenue-e021b9f0a43fc57118c72ad61dc7f4ca.mp4";